/**
 * Angular imports.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Rxjs imports.
 */
import { finalize } from 'rxjs/operators';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FileUploadService } from '../../dataservices/file-upload.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { UploadfileWithForkService } from '../../dataservices/uploadfile-with-fork.service';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';
/**
 * Modal imports.
 */
import { Post } from '../../onboarding/interface/global.model';

/**
 * Constant imports
 */
import { CREATE_STORY_TYPES, EXPLORE_SECTION, FILES_EXTENSIONS, MEDIA_DIMENSIONS, NUMBERS, PRODUCT_TYPE_CONSTANT, PROGRESS_STATUS, PROGRESS_WIDTH, REPOST_STATUS, SCREEN_NAME, STORY_CREATION_TYPE, TEMPLATE_TYPE, USER_STORY_NUDGE, POSTING_TYPE,POST_TYPE, PRODUCT_TYPE_CONSTANT_NAME, TRANSACTION_TYPE} from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';

/**
 * sdk import
 */
import { Analytics } from 'analytics2.0';
import { ERROR, SUCCESS } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * This service is specifically for the create/edit post.
 */
@Injectable({
  providedIn: 'root'
})
export class PostingService {

  /**
   * Times to stop multiple calls.
   */
  public timer = 0;

  /**
   * Current community
   */
  public selectedCommunity: string;

  /**
   * POSTING SCREEN
   */
  postingScreen: string;
  /**
   * Necessary instances.
   */
  constructor(
    private fcs: FunCollectionService,
    private dss: DataStorageService,
    private postSer: PostApiService,
    private fileus: FileUploadService,
    private fileUsFork: UploadfileWithForkService,
    public router: Router,
    private analyticsEventService: AnalyticsEventService,
    private mls: NewLanguageService,
    private analyticSdk: Analytics
  ) { }

  /**
   * feed Edit Post.
   */
  feedEditPost(): void {
    this.showProgressBar('', PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
    this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);

    const postData = this.createPostData();
    postData['feed_id'] = this.dss.posting_data.feed_edit_mode.feed_id;
    // assign data end
    const postSub = this.postSer.feedEditPost(postData)
      .pipe(finalize(() => postSub.unsubscribe()))
      .subscribe(data => {
        this.clearPostDraft();
        this.dss.nextButtonEnabled = false;
        if (data['status'] === 1) {
          if (this.dss.isRepostStatus !== NUMBERS.ZERO) {

          }
          this.showProgressBar('', PROGRESS_STATUS.COMPLETED, true, PROGRESS_WIDTH.ZERO);
          this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
          this.fcs.showSuccess(data['msg'], 'Success');
          this.sendEditFeedObj(postData.feed_id, data);
          this.dss.resetPostData();
          this.dss.resetRepostData();
          this.dss.repostType = '';
        } else if (data['status'] === 0) {
          this.fcs.errorHandeler(data);
          this.fileUsFork.chunksApiFailed();
          this.fileus.fileUploadaing_failed.next(1);
          this.dss.profileImageApi = true;
          this.dss.repostType = '';
        }
      }, () => {
        this.fileus.fileUploadaing_failed.next(1);
        this.dss.profileImageApi = true;
        this.fileUsFork.chunksApiFailed();
      });
  }

  /**
   * feed Post.
   */
  feedPost(): void {
    if (this.timer === 1) { return; }
    this.showProgressBar('', PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
    this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
    this.timer = 1;

    const postData = this.createPostData();

    const postSub = this.postSer.feedPost(postData)
      .pipe(finalize(() => postSub.unsubscribe()))
      .subscribe(data => {
        this.clearPostDraft();
        this.dss.nextButtonEnabled = false;
        if (data['status'] === 1) {
          const index = this.dss.posting_data.screen3.selected_community.findIndex((item) => {
            return item === this.selectedCommunity;
          });
          if (index === NUMBERS.MINUS_ONE) { this.router.navigateByUrl('/web/list'); }

          if (this.dss.isRepostStatus !== NUMBERS.ZERO) {

          }
          const successData: SUCCESS = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING, 
            entity_code: data.data['feed']?.product_type_id ? data.data['feed']?.product_type_id.toString() : '0',
            transaction_type: TRANSACTION_TYPE.CREATE_FEED_POST,
            current_screen_name: this.postingScreen ?? this.fcs.currentScreename,
            start_time: new Date().getTime()

          }
          this.analyticSdk.analyticService.SUCCESS(successData);
          this.showProgressBar('', PROGRESS_STATUS.COMPLETED, true, PROGRESS_WIDTH.ZERO);
          this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
          this.fcs.showSuccess(data['msg'], 'Success');
          if (this.dss.isPostSuccessShareEnabled === 1 && data.data.feed?.feed_kind != POSTING_TYPE.repost) {
            this.dss.create_Story_productData.next(data.data.feed);
            this.dss.user_story_productTypeId = data?.data?.feed?.product_type_id
            this.createStoryThroughNudge();
          }
          this.postedData(data);
          this.dss.resetPostData();
        } else if (data['status'] === 0) {
          const errorData: ERROR = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING, 
            entity_code: '0',
            transaction_type: TRANSACTION_TYPE.CREATE_FEED_POST,
            type: data['error']['code'].toString(),
            current_screen_name: this.fcs.currentScreename,
            start_time: new Date().getTime()

          }
          this.analyticSdk.analyticService.ERROR(errorData);
          this.fcs.errorHandeler(data);
          this.fileUsFork.chunksApiFailed();
          this.fileus.fileUploadaing_failed.next(1);
          this.dss.profileImageApi = true;
        }
        this.dss.resetRepostData();
      }, () => {
        this.fileus.fileUploadaing_failed.next(1);
        this.dss.profileImageApi = true;
      });
    this.timer = 0;
  }

  /**
   * Get the meta data array in JSON.
   */
  getMetaArray(): string {
    if (this.dss.posting_data.screen1.metaData) {
      return JSON.stringify(this.dss.posting_data.screen1.metaData['rawmeta']);
    }
  }

  /**
   * Get the meta data url.
   */
  getMetaUrl(): string {
    if (this.dss.posting_data.screen1.metaData) {
      return this.dss.posting_data.screen1.metaData['rawmeta'].url;
    }
  }

  /**
   * Send feed obj in case of edit.
   */
  sendEditFeedObj(feed_id: number, data): void {
    const feedObj = { feed_id: feed_id, feed_index: this.dss.posting_data.feed_edit_mode.feed_index, data: data['data'].feed };
    this.dss.edited_feed_obj.next(feedObj);
  }

  /**
   * Show/hide the post progress bar.
   */
  showProgressBar(file_url: string, status: string, is_show: boolean, progress_width: number): void {
    this.dss.post_process_obj = { file_url, status, is_show, progress_width };
  }

  /**
   * Clear the post draft data.
   */
  clearPostDraft(): void {
    if (this.dss.edit_draft_index != '' || this.dss.draft_index > -1) {
      // tslint:disable-next-line: radix
      const index = parseInt(this.dss.edit_draft_index) || this.dss.draft_index;
      this.dss.postDraftData.splice(index, 1);
      this.dss.edit_draft_index = '';
      this.dss.draft_index = -1;
      localStorage.setItem('postDraftData', JSON.stringify(this.dss.postDraftData));
      this.dss.isRepostStatus = REPOST_STATUS.ZERO;
      this.dss.webinarRepostObject = '';
    }
  }

  /**
   * Add the posted data.
   */
  postedData(data): void {
    const posted_data = {
      text_highlight: '',
      product_type: 1,
      products: []
    };
    posted_data.products.push(data['data'].feed);
    this.fileus.new_feed_post_added.next(posted_data);
  }

  /**
   * Create the post data for the edit/create post.
   */
  createPostData(): Post {
    if(this.dss.isRepostStatus === REPOST_STATUS.TWO && (this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.WEBINAR || this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.DOCTALKS ||
          this.dss.repostProductType ===  PRODUCT_TYPE_CONSTANT.FEED || this.dss.repostProductType === PRODUCT_TYPE_CONSTANT.ARTICLE)){
          this.dss.posting_data.screen1.feed_kind = POST_TYPE.REPOST;
        }
    const feedKind = this.dss.posting_data.screen1.feed_kind;
    const pollOptions = (feedKind === 'poll') ? this.dss.posting_data.screen1.poll.map(x => x.value).filter(x => x != '') : [];
    const customIds = this.dss.posting_data.screen1.tag_to.map(x => x.custom_id);
    const xCustomIds = JSON.stringify(customIds);
    if(this.dss.isRepostStatus === NUMBERS.TWO && this.dss.repostType === EXPLORE_SECTION.CME && this.dss.certificateUrl === '' ){
    this.dss.posting_data.screen1.media[0].media_url = this.dss.defaultRepost;
    }
    const postData = {
      feed_type_id: JSON.stringify(this.dss.posting_data.screen3.selected_association),
      meta_url: this.getMetaUrl(),
      feed_kind: feedKind,
      media_json: JSON.stringify(this.dss.posting_data.screen1.media),
      poll_options: JSON.stringify(pollOptions),
      speciality_json_array: JSON.stringify(this.dss.posting_data.screen2.selected_speciality.map(x => x.speciality_id)),
      title: '',
      content: this.dss.posting_data.screen1.content,
      classification: '',
      meta_array: this.getMetaArray(),
      comment_flag: 1,
      custom_ids: xCustomIds,
      is_anonymous: this.dss.posting_data.screen1.is_anonymous,
      community_id: JSON.stringify(this.dss.posting_data.screen3.selected_community),
      topic :this.dss.posting_data.screen5.selected_topic,
      repost: {
        'product_type': this.dss.repostProductType,
        'product_id': this.dss.repostProductId
      },
    };
    return postData;
  }

  /**
   * Upload the files for the post.
   */
  async uploadFile(): Promise<void> {
    if(this.dss.repostType !== EXPLORE_SECTION.CME){
      this.dss.posting_data.screen1.media = [];
    }
    if (this.dss.temp_post_media.length === 0) {
      this.showProgressBar('', PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
      this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
      this.feedPost();
      return;
    }
    this.showProgressBar(this.dss.temp_post_media[0].local, PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
    this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
    for (const element of this.dss.temp_post_media) {
      // eslint-disable-next-line no-async-promise-executor
      await new Promise<void>(async resolve => {
        const file_name = new Date().getTime() + (element.obj.name || `.${FILES_EXTENSIONS.PNG}`);
        const chunkElement = await this.fileUsFork.createChunksForFiles(element.obj, PRODUCT_TYPE_CONSTANT.FEED, element.media_type);
        if (!chunkElement || chunkElement.file_url.status === 0) {
          this.postSer.setPostButtonStatus(false);
          return false;
        }
        this.createUploadedFilesObj(element.media_type, file_name, chunkElement.file_url.data.fileurl, (chunkElement.thumbnail ? chunkElement.thumbnail.data.fileurl : ''));
        resolve();
      });
    }
    this.feedPost();
  }

  /**
   * Upload the files for the edit post.
   */
  async uploadFileForEditFeedPost(): Promise<void> {
    const media = [];
    this.dss.temp_post_media.forEach(element => {
      const x = element.local.indexOf('http');
      if (x === -1) {
        media.push(element);
      }
    });

    if (media.length === 0) {
      this.showProgressBar('', PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
      this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
      this.feedEditPost();
      return;
    }
    this.showProgressBar(media[0].local, PROGRESS_STATUS.PROCESS, true, PROGRESS_WIDTH.ONE);
    this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
    for (const element of media) {
      // eslint-disable-next-line no-async-promise-executor
      await new Promise<void>(async resolve => {

        const file_name = new Date().getTime() + (element.obj.name || `.${FILES_EXTENSIONS.PNG}`);
        const chunkElement = await this.fileUsFork.createChunksForFiles(element.obj, PRODUCT_TYPE_CONSTANT.FEED, element.media_type);

        this.createUploadedFilesObj(element.media_type, file_name, chunkElement.file_url.data.fileurl, (chunkElement.thumbnail ? chunkElement.thumbnail.data.fileurl : ''));
        resolve();
      });
    }
    this.feedEditPost();
  }

  /**
   * Create the object for the upload files.
   */
  createUploadedFilesObj(media_type, media_name, media_url, media_thumbnail): void {
    const mediaObj = {
      media_type,
      media_name,
      media_url,
      media_height: MEDIA_DIMENSIONS.HEIGHT,
      media_resolution: MEDIA_DIMENSIONS.RESOLUTION,
      media_thumbnail,
      media_width: MEDIA_DIMENSIONS.WIDTH
    };
    this.dss.posting_data.screen1.media.push(mediaObj);
  }

  /**
   * create story through nudge
   */
  createStoryThroughNudge(): void {
    if (this.dss.isPostSuccessShareEnabled === 1) {
      this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
      this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
      this.dss.storyNudgeIcon = "assets/images/feed-nudge.png";
      this.dss.storyNudgeHeading = this.mls.languageText.stories_tutorial.key33;
      this.dss.storyNudgeDisc = this.mls.languageText.stories_tutorial.key17;
      this.dss.storyType = CREATE_STORY_TYPES.REPOST;
      this.dss.storyNudgeButton =  this.mls.languageText.stories_tutorial.key16;
      this.dss.story_nudge_type = USER_STORY_NUDGE.is_story_post_success_enabled;
      this.dss.userStoryNudge.next(true);
    }
  }
}
